import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" path="/404" />
      <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center">
        <p className="font-display text-7xl text-[var(--cdt-primary)]">404</p>
        <h1 className="font-display text-2xl mt-4 text-[var(--cdt-text)]">Page not found</h1>
        <p className="mt-2 text-[var(--cdt-muted)]">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="mt-6 inline-flex items-center h-11 px-5 rounded-[var(--cdt-radius-sm)] bg-[var(--cdt-primary)] text-white font-semibold">Back to home</Link>
      </div>
    </>
  );
}
